import React from "react";

import logo1PlixImg from "../../assets/Images/logo-images/1-plix.png";
import logo2MbImg from "../../assets/Images/logo-images/2-mb.png";
import logo3OzivaImg from "../../assets/Images/logo-images/3-oziva.png";
import logo5SetuImg from "../../assets/Images/logo-images/5-setu.png";
import logo6HealthkartImg from "../../assets/Images/logo-images/6-healthkart.png";
import logo7GytreeImg from "../../assets/Images/logo-images/8-gytree.png";
import logo8MedleyImg from "../../assets/Images/logo-images/7-medley.png";
import logo9KlmImg from "../../assets/Images/logo-images/12-klm.png";
import logo12diamondsImg from "../../assets/Images/logo-images/29-diamonds.png";
import logo11WanburyImg from "../../assets/Images/logo-images/11-wanbury.png";
import logo15MncImg from "../../assets/Images/logo-images/15-mnc.png";
import logo16PureNutritionImg from "../../assets/Images/logo-images/16-pure-nutrition.png";
import logo17BatraImg from "../../assets/Images/logo-images/17-batra.png";
import logo20EthinextImg from "../../assets/Images/logo-images/20-ethinext.png";
import logo21potenciaImg from "../../assets/Images/logo-images/26-potencia.png";
import logo22tata1mgImg from "../../assets/Images/logo-images/27-tata-1-mg.png";
import logo22entodImg from "../../assets/Images/logo-images/21-entod.png";
import logo23fixupImg from "../../assets/Images/logo-images/23-fixuphealth.png";
import logo24evervitalImg from "../../assets/Images/logo-images/22-evervital.png";
import logo25xaniaImg from "../../assets/Images/logo-images/28-xania.png";
import logo27avivaImg from "../../assets/Images/logo-images/27-aviva.png";
import logo28miraculousImg from "../../assets/Images/logo-images/33-miraculous.png";
import logo29arexImg from "../../assets/Images/logo-images/13-arex.png";
import logo30kelitchImg from "../../assets/Images/logo-images/32-kelitch.png";
import logo31dwdImg from "../../assets/Images/logo-images/30-dwd.png";
import logo32glasierImg from "../../assets/Images/logo-images/31-glasier.png";
import logo33cfImg from "../../assets/Images/logo-images/28-cf.png";
import logo34zenkaImg from "../../assets/Images/logo-images/34-zenka.png";
import logo300clientsImg from "../../assets/Images/logo-images/300_Clients.png";




export default function TrustedByWellness({ logos = [] }) {

  // Default Logos
  const defaultLogos = [
    { id: 1, name: "PLIX", imageSrc: logo1PlixImg },
    { id: 2, name: "MUSCLEBLAZE", imageSrc: logo2MbImg },
    { id: 3, name: "OZIVA", imageSrc: logo3OzivaImg },
    { id: 5, name: "SETU", imageSrc: logo5SetuImg },
    { id: 6, name: "HEALTHKART", imageSrc: logo6HealthkartImg },
    { id: 7, name: "GYTREE", imageSrc: logo7GytreeImg },
    { id: 8, name: "MEDLEY", imageSrc: logo8MedleyImg },
    { id: 9, name: "KLM LAB", imageSrc: logo9KlmImg },
    { id: 10, name: "DIAMONDS", imageSrc: logo12diamondsImg },
    { id: 24, name: "POTENCIA", imageSrc: logo21potenciaImg },
    { id: 21, name: "TATA 1MG", imageSrc: logo22tata1mgImg },
    { id: 23, name: "ENTOD", imageSrc: logo22entodImg },
    { id: 27, name: "FIXUPHEALTH", imageSrc: logo23fixupImg },
    { id: 25, name: "EVERVITAL", imageSrc: logo24evervitalImg },
    { id: 11, name: "WANBURY", imageSrc: logo11WanburyImg },
    { id: 17, name: "DR.BATRA'S", imageSrc: logo17BatraImg },
    { id: 20, name: "ETHINEXT", imageSrc: logo20EthinextImg },
    { id: 15, name: "MAYLEEN", imageSrc: logo15MncImg },
    { id: 16, name: "MIRACULOUS", imageSrc: logo28miraculousImg },
    { id: 20, name: "AREX", imageSrc: logo29arexImg },
    { id: 20, name: "KELITCH", imageSrc: logo30kelitchImg },
    { id: 21, name: "DWD", imageSrc: logo31dwdImg },
    { id: 22, name: "GLASIER", imageSrc: logo32glasierImg },
    { id: 25, name: "PURENUTRITION", imageSrc: logo16PureNutritionImg },
    { id: 23, name: "XANIA", imageSrc: logo25xaniaImg },
    { id: 24, name: "AVIVA", imageSrc: logo27avivaImg },
    { id: 25, name: "ZENKA", imageSrc: logo34zenkaImg },
    { id: 26, name: "CF", imageSrc: logo33cfImg },
    { id: 26, name: "300+CLIENTS", imageSrc: logo300clientsImg },
    
  ];

  const displayLogos = logos.length > 0 ? logos : defaultLogos;

  return (
    <section className="w-full bg-white py-16 sm:py-20 lg:py-24 overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .logo-card {
          transition: all 0.4s ease;
          border: 1px solid rgba(164,190,44,0.08);
        }

        .logo-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.08);
          border-color: rgba(164,190,44,0.25);
        }

          .logo-card img {
            transition: all 0.4s ease;
          }

          .logo-card:hover img {
            transform: scale(1.08);
          }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* HEADING */}
        <div className="text-center mb-14 lg:mb-20">

          {/* Small Label */}
          <p className="text-[#6B8A1A] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
            TRUSTED PARTNERS
          </p>

          {/* Main Heading */}
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#355931] leading-tight">
            Trusted by Wellness  <span className="gradient-text">Seekers Worldwide </span>
          </h2>

          {/* Underline */}
          <div
            className="w-24 h-[2px] mx-auto mt-6 mb-6"
            style={{
              background:
                "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
            }}
          />

          {/* Description */}
          <p className="max-w-2xl mx-auto text-gray-600 text-sm sm:text-base leading-relaxed px-2">
            Collaborating with leading wellness, nutraceutical,
            healthcare, and lifestyle brands across global markets
            through innovation, quality, and trusted manufacturing.
          </p>

        </div>

        {/* LOGO GRID */}
        <div className="
          grid
          grid-cols-2
          sm:grid-cols-3
          md:grid-cols-4
          lg:grid-cols-5
          gap-4
          sm:gap-5
          lg:gap-6
        ">

          {displayLogos.map((logo) => (

            <div
              key={logo.id}
              className="
                logo-card
                bg-white
                rounded-[24px]
                p-5
                sm:p-6
                flex
                items-center
                justify-center
                min-h-[110px]
                sm:min-h-[130px]
                cursor-pointer
              "
            >

              {logo.imageSrc ? (

                <img
                  src={logo.imageSrc}
                  alt={logo.name}
                  className="
                    w-full
                    max-w-[120px]
                    sm:max-w-[140px]
                    h-auto
                    object-contain
                  "
                />

              ) : (

                <p className="text-sm font-semibold text-gray-400 text-center">
                  {logo.name}
                </p>

              )}

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}